import { SearchInput } from '../shared';
import { SortOrder, CustomerEmployeeSortType } from '../enums';

export class GetCustomerEmployeesInput extends SearchInput<CustomerEmployeeSortType> {
    constructor() {
        super(CustomerEmployeeSortType.FullName);
        this.sortOrder = SortOrder.Ascending;
    }
}
